import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

export default function EarningsCallTranscriptListDataGrid({transcript_list} :any) {
  const columns = [
    { field: 'id', headerName: 'Date', width: 200, renderHeader:(params) => ( <strong>Date</strong>) },
    { field: 'name', headerName: 'Transcript', width: 200, renderHeader:(params) => ( <strong>Transcript</strong>), renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={params.getValue(params.id, 'path') }><strong>{params.value}</strong></a>)},
    { field: 'quarter', headerName: 'Quarter', width: 200, renderHeader:(params) => ( <strong>Quarter</strong>) },
    { field: 'year', headerName: 'Year', width: 200, renderHeader:(params) => ( <strong>Year</strong>) },
  ];

  const rows = transcript_list.data;

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      pageSize={10}
      rowsPerPageOptions={[10]}
      autoHeight={true}
      autoPageSize={true}
      density={"compact"}
      disableColumnMenu
    />
  );
}
